import { render, staticRenderFns } from "./SuppliesStockMonthlyClosing.vue?vue&type=template&id=22bd5722&scoped=true&"
import script from "./SuppliesStockMonthlyClosing.vue?vue&type=script&lang=js&"
export * from "./SuppliesStockMonthlyClosing.vue?vue&type=script&lang=js&"
import style0 from "./SuppliesStockMonthlyClosing.vue?vue&type=style&index=0&id=22bd5722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bd5722",
  null
  
)

export default component.exports